import styled, { css, keyframes } from 'styled-components';

const dropSquash = keyframes`
  0% {
    transform: translate(-50%, -150%) scaleY(1);
  }
  30% {
    transform: translate(-50%, -100%) scaleY(0.8);
  }
  75% {
    transform: translate(-50%, -105%) scaleY(1.1);
  }
  100% {
    transform: translate(-50%, -100%) scaleY(1);
  }
`;

export const mapModalStyles = css`
  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    height: calc(100% - 130px);
    width: calc(100% - 150px);
    padding: 40px;

    > div {
      border-radius: 14px;
    }
  }
`;

export const saveButtonStyles = css`
  position: absolute;
  bottom: 30px;
  height: 54px;
  border-radius: 14px;
  z-index: 10;
  width: calc(100% - 30px);
  left: 15px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    left: unset;
    width: 340px;
    right: 70px;
    bottom: 70px;
  }
`;

export const closeButtonStyles = (isWebView: boolean) => css`
  position: absolute;
  z-index: 10;
  top: ${isWebView
    ? 'calc(20px + max(env(safe-area-inset-top), 40px))'
    : '20px'};
  left: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 13.5px 10px 10px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    left: unset;
    right: 70px;
    top: 70px;
  }
`;

export const MapContainer = styled.div<{ $height: string }>`
  position: relative;
  height: ${({ $height }) => $height};
`;

export const ShadowDot = styled.div<{ $dragging: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 6px;
  height: 6px;
  background-color: ${({ theme }) => theme.colors.systemColors.blue};
  border-radius: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;

  ${({ $dragging }) =>
    !$dragging &&
    css`
      opacity: 0;
      visibility: hidden;
    `}
`;

export const Pin = styled.div<{ $dragging: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 48px;
  pointer-events: none;
  transform-origin: bottom center;

  ${({ $dragging }) =>
    $dragging
      ? css`
          transform: translate(-50%, -150%) scale(1, 1);
        `
      : css`
          transform: translate(-50%, -100%) scale(1, 1);
          animation: ${dropSquash} 0.5s ease-out forwards;
        `}

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
`;
